import { styled } from "@mui/material/styles";
const SkeletonWrapper = styled("div")`
  height: 56px;
  width: 100%;
`;
const SkeletonDetailsWrapper = styled("div")`
  display: flex;
  align-items: center;
  padding: 18px 16px;
  gap: 16px;
  width: 100%;
  box-sizing: border-box;
`;
const GroupHeader = styled("div")(({ theme }) => ({
  position: "sticky",
  zIndex: 3,
  top: "-8px",
  padding: "12px 16px",
  borderTop: `1px solid ${theme.palette.grey[300]}`,
  color: theme.palette.grey[800],
  backgroundColor: theme.palette.common.white
}));
const GroupItems = styled("ul")`
  padding: 0;
`;
const GroupListWrapper = styled("li")`
  padding: 0;
  list-style: none;
`;
export {
  GroupHeader,
  GroupItems,
  GroupListWrapper,
  SkeletonDetailsWrapper,
  SkeletonWrapper
};
